/* eslint-disable */

import { BrowserRouter, RouterProvider, Routes , Route} from "react-router-dom";
import Loader from './components/loader'
import router, { routes } from './data/routes'

import Navbar from "./components/navbar";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";


function App() {
  return (

    <BrowserRouter>

         
      <div>

        <div className="container-xxl bg-white p-0">
          {/* Spinner Start */}
          <Loader />
          <div className="container-xxl position-relative p-0">
            < Navbar />
          </div>

          <Routes>
            {
              routes && routes?.map(route => {
                return < Route path={route.path} element={route.element} loader={route.loader}/>
              })
            }
            <Route path="/"   />

          </Routes>
          <Footer />
          <BackToTop />

        </div>
      </div>



    </BrowserRouter>




  );
}

export default App
